import * as React from 'react';
import { ValidateMessages } from 'rc-field-form/lib/interface';
import defaultLocaleData from '../../locale/en_US';

interface Locale {
    Form?: {
        optional?: string;
        defaultValidateMessages: ValidateMessages;
    };
}

const LocaleContext = React.createContext<(Partial<Locale> & { exist?: boolean }) | undefined>(undefined);

type LocaleComponent = keyof Locale;

export function useLocaleReceiver<T extends LocaleComponent>(
    componentName: T,
    defaultLocale?: Locale[T] | Function,
): [Locale[T]] {
    const antLocale = React.useContext(LocaleContext);

    const componentLocale = React.useMemo(() => {
        const locale = defaultLocale || (defaultLocaleData as any)[componentName || 'global'];
        const localeFromContext = componentName && antLocale ? antLocale[componentName] : {};

        return {
            ...(typeof locale === 'function' ? (locale as Function)() : locale),
            ...(localeFromContext || {}),
        };
    }, [componentName, defaultLocale, antLocale]);

    return [componentLocale];
}


// WEBPACK FOOTER //
// ./src/components/simple-form/utils/useLocalReceiver.ts